import React from "react";
import { RecoilRoot } from "recoil";
import CustomRoutes from "./router";
import { BrowserRouter as Router } from "react-router-dom";
import AxiosContextProvider from "./contexts/AxiosContext";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <RecoilRoot>
      <Router>
        <AxiosContextProvider>
          <QueryClientProvider client={queryClient}>
            <CustomRoutes />
          </QueryClientProvider>
        </AxiosContextProvider>
      </Router>
    </RecoilRoot>
  );
}

export default App;
